export const specificFacetSearchStateSelector = (state, facetId) => state.facetSearchSet[facetId];
